<script lang="ts" setup>
import LoadingSkeleton from '@/sharedComponents/LoadingSkeleton.vue'

defineProps<{
  isFocused: boolean
  isSelected: boolean
  isInSelectedRange?: boolean
  loading: boolean
}>()
</script>

<template>
  <div
    class="group/cell relative inline-flex h-8 items-center justify-start border-r border-b border-border-subtle group-first/row:before:-top-0 group-last/row:before:bottom-0 focus:outline-hidden"
    :class="[
      isSelected && [
        'before:pointer-events-none',
        'before:absolute before:inset-[-2px]',
        'before:bottom-[-2px] before:rounded-md',
        'before:border-border-focused',
        'before:border-2',
        'before:w-[calc(100%+4px)]',
        'before:h-[calc(100%+4px)]',
        'group-first/row:before:top-[-2px]',
        'before:z-2',
      ],
      isInSelectedRange &&
        !isSelected &&
        'after:pointer-events-none after:absolute after:top-0 after:left-0 after:size-full after:bg-background-selected!',
      !isFocused && 'cursor-default',
      loading && 'p-1',
    ]"
  >
    <LoadingSkeleton
      v-if="loading"
      class="size-full"
      status
    />
    <slot v-else />
  </div>
</template>
